import Device from 'Faster/model/Device';
import DeviceService from 'Faster/service/DeviceService';

class FasterDevice {
  private deviceService: DeviceService;

  public constructor(deviceService: DeviceService) {
    this.deviceService = deviceService;
  }

  public get(): Device | undefined {
    return this.deviceService.get();
  }

  public putProperty(name: string, value: string | number | boolean): void {
    this.putProperties({
      [name]: value,
    });
  }

  public updatePushToken(pushSubscription: PushSubscription): void {
    if (pushSubscription == undefined) {
      console.warn('Invalid Push Token, undefined is not an PushSubscription object');
      return;
    }

    const device = this.deviceService.get();
    const updatedDevice = device.withUpdatedPushToken(JSON.stringify(pushSubscription));

    this.deviceService.updateDeviceData(updatedDevice);
  }

  public putProperties(properties: object): void {
    if (!this.propertiesHaveValidTypes(properties)) {
      console.warn('Unsupported device property, only boolean, number or string are permitted');

      return;
    }

    const protectedKeys = this.getProtectedKey(properties);
    if (protectedKeys.length > 0) {
      console.warn(
        `Protected properties found: ${protectedKeys}. You can not overwrite it, rename the specified properties`
      );

      return;
    }

    const device = this.deviceService.get();
    const updatedDevice = device.withAddedProperties(properties);

    this.deviceService.updateDeviceData(updatedDevice);
  }

  public removeProperty(name: string): void {
    const device = this.deviceService.get();
    const updatedDevice = device.withRemovedProperty(name);

    this.deviceService.updateDeviceData(updatedDevice);
  }

  private propertiesHaveValidTypes(properties: object): boolean {
    const validTypes = ['string', 'boolean', 'number'];
    const propertyArray = Object.values(properties);
    const foundInvalid = propertyArray.some((value): boolean => !validTypes.includes(typeof value));

    return !foundInvalid;
  }

  private getProtectedKey(properties: object): string[] {
    const proptectedKeys = ['browserName', 'browserVersion'];
    const propertyKeys = Object.keys(properties);
    const foundProtectedKeys = proptectedKeys.filter((key): boolean => propertyKeys.includes(key));

    return foundProtectedKeys;
  }
}

export default FasterDevice;
